<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <content-field
          label="Name"
          @blur="$v.formData.name.$touch()"
          :error="$v.formData.name"
          v-model="formData.name">
        </content-field>
      </v-flex>

      <v-flex xs12>
        <v-select
          :items="categories"
          v-model="formData.awardsType"
          label="Type"
        />
      </v-flex>

      <v-flex xs12>
        <content-field
          v-if="formData.awardsType === 'Company'"
          label="Email"
          @blur="$v.formData.metadata.email.$touch()"
          :error="$v.formData.metadata.email"
          v-model="formData.metadata.email" />
      </v-flex>

      <v-flex xs12>
        <content-field
          v-if="formData.awardsType === 'Individual'"
          label="Job Title"
          @blur="$v.formData.jobTitle.$touch()"
          :error="$v.formData.jobTitle"
          v-model="formData.jobTitle" />
      </v-flex>

      <v-flex xs12>
        <content-field
          v-if="formData.awardsType === 'Individual'"
          label="Company"
          @blur="$v.formData.company.$touch()"
          :error="$v.formData.company"
          v-model="formData.company" />
      </v-flex>

      <v-flex xs12>
        <content-field
          v-if="formData.awardsType === 'Individual'"
          label="Biography"
          @blur="$v.formData.biography.$touch()"
          :error="$v.formData.biography"
          v-model="formData.biography" />
      </v-flex>

      <v-flex xs12>
        <content-field
          v-if="formData.awardsType === 'Individual'"
          label="Linkedin"
          @blur="$v.formData.linkedin.$touch()"
          :error="$v.formData.linkedin"
          v-model="formData.linkedin" />
      </v-flex>

      <v-flex xs12>
        <content-field
          label="Description"
          @blur="$v.formData.description.$touch()"
          :error="$v.formData.description"
          v-model="formData.description" />
      </v-flex>

      <v-flex xs12>
        <v-textarea
          label="Eligibility"
          v-model="formData.eligibility"
        ></v-textarea>
      </v-flex>

      <v-flex xs12>
        <v-select
          label="Select categories"
          :items="getNominationsCategories"
          item-text="title"
          item-value="id"
          @blur="$v.formData.categoriesIds.$touch()"
          :error="$v.formData.categoriesIds.$invalid && $v.formData.categoriesIds.$dirty"
          v-model="formData.categoriesIds"
          multiple
          max-height="400"
        />
        <div
          v-if="$v.formData.categoriesIds.$invalid && $v.formData.categoriesIds.$dirty"
          class="error-message"
        >The field is required
        </div>
      </v-flex>

      <v-flex xs12>
        <v-select
          v-model="formData.votingStep"
          :items="nomineeVotingSteps"
          label="Voting Step"
        />
      </v-flex>

      <v-flex xs12>
        <v-select
          v-model="formData.status"
          :items="nomineeStatuses"
          label="Status"
          v-if="editableItem"
        />
      </v-flex>

      <v-flex class="pt-4 text-xs-center">
        <v-card-title><h3>Logo image</h3></v-card-title>
        <v-card-media
          v-if="formData.logoUrl"
          :src="formData.logoUrl"
          height="200px"
          class="image-style"
        />
        <a-upload-section
          class="upload-button"
          :btnAppearance="btnAppearance"
          @lastUploadedPhotos="handleLogo"
        />
        <v-btn
          v-if="formData.logoUrl"
          color="success"
          target="_blank"
          outlined
          :href="formData.logoUrl"
          download>
            Download Image
        </v-btn>
        <v-btn
          v-if="formData.logoUrl"
          color="success"
          @click="formData.logoUrl = ''">
            Remove Image
        </v-btn>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import AUploadSection from '@/components/shared/AUploadSection'
  import { required } from 'vuelidate/lib/validators'
  import { clone, pathOr, isNil, compose, head } from 'ramda'

  export default {
    name: "nominee-form",
    components: {
      AUploadSection
    },
    props: {
      editableItem: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        categories: ['Company', 'Individual'],
        formData: {
          name: '',
          email: '',
          description: '',
          eligibility: '',
          logoUrl: '',
          awardsType: 'Company',
          categoriesIds: [],
          status: '',
          votingStep: '',
          jobTitle: '',
          company: '',
          biography: '',
          linkedin: '',
          metadata: {}
        },
        nomineeStatuses: [
          'Approved',
          'Draft',
          'Deleted'
        ],
        nomineeVotingSteps: [
          'Vote1Phase',
          'Vote2Phase',
          'Wining'
        ],
        btnAppearance: {
          text: 'Choose Image',
          color: 'success',
          raised: true,
          hideIcon: true
        }
      }
    },
    validations: {
      formData: {
        name: { required },
        awardsType: { required },
        description: { required },
        logoUrl: { required },
        categoriesIds: { required },
        metadata: {
          email: { required }
        }
      }
    },
    computed: {
      ...mapGetters([
        'getNominationsCategories',
        'getAllNomineesWithWinnerStatus'
      ])
    },
    watch: {
      editableItem: {
        handler (val) {
          if (!isNil(val)) {
            this.formData = clone(this.editableItem)
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions([
        'addNominee',
        'fetchNomineesListWithWiningStatus',
        'editNominee',
        'showError'
      ]),
      toggleModal () {
        this.modalGallery =! this.modalGallery
      },
      handleLogo (photos) {
        const choseUrl = (urls) => urls.small || urls.medium || urls.large || urls.originalImageUrl
        this.formData.logoUrl = compose(choseUrl, pathOr({}, ['imagesUrls']), head)(photos)
      },
      async saveNomineeItem () {
        this.$v.formData.$touch()
        if (this.$v.formData.$invalid) {
          return 'modal window stay open'
        } else if (this.editableItem) {
          const IsWinnerInCategories = pathOr(null, ['categoriesIds'], this.formData).find((categoriesId) => {
            return this.getAllNomineesWithWinnerStatus.find((categoriesIdWithWinner) => {
               return pathOr(null, ['categoriesIds'], categoriesIdWithWinner).find((category) => {
                 return pathOr('', ['id'], this.formData) !== pathOr('', ['id'], categoriesIdWithWinner) && categoriesId === category && pathOr('', ['VotingStep'], this.formData) === 'Wining'
               })
             })
          })
          if (IsWinnerInCategories === undefined) {
            try {
              delete this.formData.metadata
              await this.fetchNomineesListWithWiningStatus()
              await this.editNominee(this.formData)
            } catch (err) {
              throw err
            }
          } else {
            this.showError()
            return 'modal window stay open'
          }
        } else {
          try {
            await this.addNominee(this.formData)
          } catch (err) {
            throw err
          }
        }
        return true
      }
    },
    mounted () {
      if (!isNil(this.editableItem)) {
        this.formData = clone(this.editableItem)
      }
    },
    created () {
      this.fetchNomineesListWithWiningStatus()
    }
  }
</script>

<style scoped>
  .error-message {
    font-size: 13px;
    color: #ff171e;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Awards/Nominee/nomineeForm.vue